import { IntegrationMaintenanceFilters } from './integration-maintenance-filters';

export class IntegrationMaintenance {
    integrationMaintenanceId: string;
    maintenanceStartTime: Date;
    maintenanceStopTime: Date;
    isActive: boolean;
    createdOn: Date;
    updatedOn: Date;
    maintenanceFilters: IntegrationMaintenanceFilters;
  }
